import React from 'react';
import {c_zones} from '../a-Graphic/Colors';

import getMyMap, {createNamesLayer, createCommunesLayer, createCommunesNamesLayerEasy} from '../b-LeafletMap/leaflet_map';

import ZonesItemExchange from './ZonesItemExchange'
import ZonesItem from './ZonesItem'
import PlotPie from '../c-PlotlyFigures/PlotPie'


class Zones extends React.Component {
   constructor(props) {
    super(props);

    this.state = {
      unit: "distance",
      label: "km"
    };
  }

  setUnit = (unit, label) => {
      this.setState({
        unit: unit,
        label: label
      })
  }

  componentDidMount() {
    /* COMMUNES */
    var communes = this.props.territory.communes;

    var zm = this.props.territory.all_travels.zones_means;
    var zones = Object.keys(zm).map((z) => parseFloat(z)).filter((zm) => zm>0);

    let main_zones = zones.slice(0, -1)
    var communes_coords_mz = communes.filter((c)=>main_zones.includes(c.zone)).map((c) => c.center);
    var communes_names_mz = communes.filter((c)=>main_zones.includes(c.zone)).map((c) => c.name);


    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.1);

    // --- create layers
    var layer_names = createCommunesNamesLayerEasy(mymap, communes);
    zones.map((z)=>
      layer_names.addLayer(createCommunesLayer(mymap, communes.filter((c)=>c.zone==z),
                                                      communes.filter((c)=>c.zone==z).map((c) => c.name + " - Zone " + z),
                                                      c_zones[z]))
    )

    // --- center the map
    mymap.fitBounds(layer_names.getBounds());
  }

    render(){
      function label_text(status){
        var total = Object.values(status).reduce((a,b) => a + b);
        var text = Object.fromEntries(
                    Object.entries(status).map(
                      ([k, v], i) => [k, "<span style='font-size: 15px;'>" + Math.round(v/total*1000)/10 +
                                        " %</span></br></br><span style='font-weight: 300; font-size: 15px'>" + k + "</span>" ]
                    )
                  );
        return(Object.values(text))
      }

      function hover_text(status){
        var text = Object.fromEntries(
                    Object.entries(status).map(
                      ([k, v], i) => [k, k + "</br></br><span style='font-weight: 300;'>" + Math.round(v) + " déplacements</span>"]
                    )
                  );
        return(Object.values(text))
      }
      function filter_domicile(data){
        return Object.assign({}, ...Object.entries(data).filter(([k,v]) => k != "domicile").map(([k,v]) => ({[k]:v})));
      }

      var territory = this.props.territory;
      var zm = this.props.territory.all_travels.zones_means;
      var zmg = this.props.territory.all_travels.zones_means_global;
      var zones = Object.keys(zm);
      var zones_nb = Math.max(...zones.map((z)=>parseFloat(z)));

      var prop_travels_with_no_zone = Math.round(territory.all_travels.zones_no_zone[this.state.unit]/territory.all_travels.total[this.state.unit]*1000)/10
      let z =3

      return(
        <div className="row mt-5">
          <div className="col">

          <div className="row">
            <div className="col-auto">
              <h3 className="mb-3">modes de déplacements au sein et entre zones</h3>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div style={{height: "400px"}} id="zones"></div>
            </div>
          </div>

          <div className="row mt-4 mb-4">
          <div className="col-2">
            <p onClick={this.setUnit.bind(this, "distance", "km")}
               className={this.state.unit == "distance" ? "button p-1 active" : "button p-1"}>Distance parcourue</p>
          </div>
            <div className="col-2 pl-0">
              <p onClick={this.setUnit.bind(this, "number", "déplacements")}
                 className={this.state.unit == "number" ? "button p-1 active" : "button p-1"}>Nombre de déplacements</p>
            </div>
            <div className="col-2 pl-0">
              <p onClick={this.setUnit.bind(this, "ghg_emissions", "tCO2eq")}
                 className={this.state.unit == "ghg_emissions" ? "button p-1 active" : "button p-1"}>Emissions de GES</p>
            </div>
          </div>

            <div className="row">
            {[...Array(zones_nb + 1).keys()].slice(1,).map((z)=>
              <div className={"col-" + 12/(zones_nb+1)}>
                <ZonesItem territory={territory} unit={this.state.unit} main_zone={z} zones_nb={zones_nb} label={this.state.label} />
              </div>
            )}
              <div className={"col-" + 12/(zones_nb+1)}>
                <ZonesItem territory={territory} unit={this.state.unit} main_zone={-1} zones_nb={zones_nb} label={this.state.label} />
              </div>
            </div>

            {zones_nb == 3 &&
            <div className="row">
              <div className="col-9">
                <div className="row">
                  <div className="col">
                    <ZonesItemExchange territory={territory} unit={this.state.unit} zone_from={1} zone_to={2} label={this.state.label}/>
                  </div>
                  <div className="col">
                    <ZonesItemExchange territory={territory} unit={this.state.unit} zone_from={2} zone_to={3} label={this.state.label}/>
                  </div>
                </div>
              </div>
            </div>}

          {zones_nb == 3 &&
            <div className="row">
              <div className="col-9">
                <div className="row">
                  <div className="col">
                    <ZonesItemExchange territory={territory} unit={this.state.unit} zone_from={1} zone_to={3} label={this.state.label}/>
                  </div>
                </div>
              </div>
            </div>}

            {zones_nb == 2 &&
            <div className="row">
              <div className="col-8">
                <div className="row">
                  <div className="col">
                    <ZonesItemExchange territory={territory} unit={this.state.unit} zone_from={1} zone_to={2} label={this.state.label}/>
                  </div>
                </div>
              </div>
            </div>}

            {[...Array(zones_nb + 1).keys()].slice(1,).reverse().map((z)=>
              <div className="row">
                <div className={"col offset-" + (12/(zones_nb+1)*(z-1))}>
                  <ZonesItemExchange territory={territory} unit={this.state.unit} zone_from={z} zone_to={-1} label={this.state.label}/>
                </div>
              </div>
            )}


            <div className="row mt-1 mb-4">
              <div className="col-12">
                <p>L'origine ou la destination de certains déplacements n'ont pas pu être identifiées, ils représentent {prop_travels_with_no_zone}% des déplacements.</p>
              </div>
            </div>


          </div>
        </div>

    );
  }
}

export default Zones;
